import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {utils, authActions} from "@mc/mc-legacy";
import {withRouter} from "react-router";
import BaseAppWrapper from "../components/BaseAppWrapper";
import {Component} from "react";
import * as React from "react";

/**
 * Wrapper pro stránky aplikace.
 */
class AppWrapper extends Component {

    static propTypes = {
        logoUrl: PropTypes.string,
        nazevSpolecnost: PropTypes.string,
        homeLink: PropTypes.string,
        userMenuAddons: PropTypes.array,
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(authActions.fetchAuthInfoIfNeeded());
    };

    handleLogout = () => {
        this.props.dispatch(authActions.logout());
        this.props.location.state = undefined; // smazání případné URL pro přesměrování po přihlášení
    };

    handleHistoryGoBack = (goBackBase, homeLink) => {
        if (goBackBase) {   // jdeme na nejbližší, která NEBUDE mít goBackBase
            let i = window.appHistory.length - 1;
            let found = false;
            while (i >= 0) {
                if (window.appHistory[i].substring(0, goBackBase.length) !== goBackBase) {
                    // Pokud se liší první, který je v historii, přeskočíme ho, protože by se při back nic nestalo
                    const size = window.appHistory.length - i - 1;
                    if (size > 0) {
                        found = true;
                        this.props.history.go(-size);
                        break;
                    }
                }
                i--;
            }
            // Jdeme na homeLink
            if (!found) {
                if (typeof homeLink === "function") {
                    homeLink();
                } else {
                    this.props.history.push(homeLink);
                }
            }
        } else {
            this.props.history.goBack()
        }
    };

    render() {
        const {userMenuAddons, authInfo, ...other} = this.props;
        const authStatus = authInfo.data;

        // Usermenu
        const appUserMenuAddons = [];
        if (userMenuAddons) {
            appUserMenuAddons.push(...userMenuAddons);
        }

        return <BaseAppWrapper
            onLogout={this.handleLogout}
            userMenuAddons={appUserMenuAddons}
            authStatus={authStatus}
            onHistoryGoBack={this.handleHistoryGoBack}
            {...other}
        />
    }
}

function mapStateToProps(state) {
    return {
        authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(AppWrapper));
